import React, { useState, useEffect ,useRef } from "react";
import L from "leaflet";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  
} from "react-leaflet";
import { Checkbox,Button, Col, Row,notification } from "antd";
import Routing from "../MapRoutes/MapRoutes";
import Billing_rr from "../Billing/Billing_rr";

import "./Map_polilineas.scss";
import "leaflet/dist/leaflet.css";


export default function Map_real(props) { 
  const { coordenadas,routes_data,total } = props;
  const [checked, setchecked] = useState([]);
  const [iva, setiva] = useState(10);
  const [checked_r, setchecked_r] = useState([]);
  const mapRef = useRef();
  var puntos = [];
  var puntos_r = [];
  var puntos2 = [];
  var puntos3 = [];
  var puntos3_r = [];
  var peso=[];
  var volumen=[];
  var altura=[]
  var difaltura=[]
  var peso_r=[];
  var volumen_r=[];
  var altura_r=[]
  var difaltura_r=[]
  var rutas=[]
  var rutas_r=[]
  var pendientes=[]
  var pendientes_r=[]
  var orden = "";
  var color='white';
  var colorP='red';
  var dif=0;
  var difpen=0;
  var auxiliares=[];
  var vehicleType=[];
  var auxiliare=[];
  var auxiliares_r=[];
  var vehicleType_r=[];
  var auxiliare_r=[];
  var puntoHub;
  var nombreHub;
  var ant=0;
  var elementAnt;

  console.log('estas son las coordenadas',coordenadas,routes_data,total);

  
  function copiarTexto(locations) {  
    const origin = locations[0];
    const destination = locations[locations.length - 1];
    const waypoints = locations.slice(1, -1);
    
    let url = `https://www.google.com/maps/dir/?api=1&destination=${destination[0]},${destination[1]}&origin=${origin[0]},${origin[1]}&waypoints=`;
    waypoints.forEach(waypoint => {
      url += `${waypoint[0]},${waypoint[1]}|`;
    });
    url = url.slice(0, -1);
    url += '&travelmode=bicycling&dir_action=navigate';
    navigator.clipboard.writeText(url);
    // console.log('Texto copiado al portapapeles:', url);
    notification["success"]({
      message: `Enlace copiado en portapapeles`
    })
    return url;
  };

  const objectMap1 = {};
  total.IN1_Orders.forEach(obj => {
    objectMap1[obj.order_id] = obj;
  });
  const objectMap2 = {};
  total.IN3_TranspTypes.forEach(obj => {
    objectMap2[obj.transptype_id] = obj;
  });
  const objectMap3 = {};
  total.IN2_Hubs.forEach(obj => {
    objectMap3[obj.hub_id] = obj;
  });
  const objectMap4 = {};
  routes_data.routes_data.forEach(obj => {
    objectMap4[obj.id_tour] = obj;
  });
  console.log('objectMap1: ',objectMap1)
  console.log('objectMap2: ',objectMap2)
  console.log('objectMap3: ',objectMap3)
  console.log('objectMap4: ',objectMap4)


  for (let i = 0; i < routes_data.routes_orders.length; i++) {
    var x=routes_data.routes_orders[i]
    if(i!==0)var x_ant=routes_data.routes_orders[i-1]
            
    if(objectMap1[x.order_id].order_mode==='shipment'){
      if(i!==0&&x.order_id===x_ant.order_id){
        puntos3.push({
          order_id:objectMap1[x.order_id].order_id,
          punto1: [objectMap1[x.order_id].order_lat2, objectMap1[x.order_id].order_lon2,''],
          earlyTime1: objectMap1[x.order_id].order_earlytime2,
          lateTime1:objectMap1[x.order_id].order_latetime2,
          servicetime1:objectMap1[x.order_id].order_servicetime2,
          position:'while',
          nombre: objectMap1[x.order_id].order_id,
          tour_info: {
            transptype_type: objectMap2[objectMap4[x.order_idtour].veh_id].transptype_routing,
            order_tour:x.order_idtour,
            order_pos:x.order_position,
            order_vehicle:objectMap4[x.order_idtour].veh_id,
            transptype:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_name,
            transptype_capacity_items:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_capacityitems,
            transptype_capacity_weight:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_capacityweight,
          },
          sumItems:0.0,
          sumWeight:0.0,
          numberItems: objectMap1[x.order_id].order_items,
          color: "yellow",
          order_mode:objectMap1[x.order_id].order_mode,
          peso:objectMap1[x.order_id].order_weight,
          hub:objectMap1[x.order_id].order_idhub,
          order_revenue:objectMap1[x.order_id].order_revenue
        });
      }else{
        puntos3.push({
          order_id:objectMap1[x.order_id].order_id,
          punto1: [objectMap1[x.order_id].order_lat1, objectMap1[x.order_id].order_lon1,''],
          earlyTime1: objectMap1[x.order_id].order_earlytime1,
          lateTime1:objectMap1[x.order_id].order_latetime1,
          servicetime1:objectMap1[x.order_id].order_servicetime1,
          position:'while',
          nombre: objectMap1[x.order_id].order_id,
          tour_info: {
            transptype_type: objectMap2[objectMap4[x.order_idtour].veh_id].transptype_routing,
            order_tour:x.order_idtour,
            order_pos:x.order_position,
            order_vehicle:objectMap4[x.order_idtour].veh_id,
            transptype:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_name,
            transptype_capacity_items:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_capacityitems,
            transptype_capacity_weight:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_capacityweight,
          },
          sumItems:0.0,
          sumWeight:0.0,
          numberItems: objectMap1[x.order_id].order_items,
          color: "yellow",
          order_mode:objectMap1[x.order_id].order_mode,
          peso:objectMap1[x.order_id].order_weight,
          hub:objectMap1[x.order_id].order_idhub,
          order_revenue:objectMap1[x.order_id].order_revenue
        });
      }
    }else{
      puntos3.push({
        order_id:objectMap1[x.order_id].order_id,
        punto1: [objectMap1[x.order_id].order_lat1, objectMap1[x.order_id].order_lon1,''],
        earlyTime1: objectMap1[x.order_id].order_earlytime1,
        lateTime1:objectMap1[x.order_id].order_latetime1,
        servicetime1:objectMap1[x.order_id].order_servicetime1,
        position:'while',
        nombre: objectMap1[x.order_id].order_id,
        tour_info: {
          transptype_type: objectMap2[objectMap4[x.order_idtour].veh_id].transptype_routing,
          order_tour:x.order_idtour,
          order_pos:x.order_position,
          order_vehicle:objectMap4[x.order_idtour].veh_id,
          transptype:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_name,
          transptype_capacity_items:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_capacityitems,
          transptype_capacity_weight:objectMap2[objectMap4[x.order_idtour].veh_id].transptype_capacityweight,
        },
        sumItems:0.0,
        sumWeight:0.0,
        numberItems: objectMap1[x.order_id].order_items,
        color: "yellow",
        order_mode:objectMap1[x.order_id].order_mode,
        peso:objectMap1[x.order_id].order_weight,
        hub:objectMap1[x.order_id].order_idhub,
        order_revenue:objectMap1[x.order_id].order_revenue
      });
    }
  }

  puntos3.sort(function (a, b) {
    if (a.tour_info.order_tour > b.tour_info.order_tour) {
      return 1;
    } else if (a.tour_info.order_tour < b.tour_info.order_tour) {
      return -1;
    } else {
      if (a.tour_info.order_pos < b.tour_info.order_pos) {
        return -1;
      } else if (a.tour_info.order_tour > b.tour_info.order_tour) {
        return 1;
      } else {
        return 0;
      }
    }
  });

  puntos3.forEach(element => {
    if(element.tour_info.order_pos===1 && ant!==0){
      puntos3.push({
        position:'end',
        sumItems:0.0,
        sumWeight:0.0,
        punto1:  [objectMap3[objectMap1[elementAnt.order_id].order_idhub].hub_lat, objectMap3[objectMap1[elementAnt.order_id].order_idhub].hub_lon,''],
        nombre: objectMap3[objectMap1[elementAnt.order_id].order_idhub].hub_name,
        tour_info: {
          order_tour:elementAnt.tour_info.order_tour,
          order_pos:elementAnt.tour_info.order_pos+1,
          order_vehicle:0,
          transptype:'',
          transptype_capacity_items:0.0,
          transptype_capacity_weight:0.0,
        },
      });

      puntos3.push({
        position:'begin',
        sumItems:0.0,
        sumWeight:0.0,
        punto1:  [objectMap3[objectMap1[element.order_id].order_idhub].hub_lat, objectMap3[objectMap1[element.order_id].order_idhub].hub_lon,''],
        nombre: objectMap3[objectMap1[element.order_id].order_idhub].hub_name,
        tour_info: {
          order_tour:element.tour_info.order_tour,
          order_pos:0,
          order_vehicle:0,
          transptype_type:element.tour_info.transptype_type,
          transptype:'',
          transptype_capacity_items:0.0,
          transptype_capacity_weight:0.0,
        },
      });
    }else if(element.tour_info.order_pos===1){
      puntos3.push({
        position:'begin',
        sumItems:0.0,
        sumWeight:0.0,
        punto1:  [objectMap3[objectMap1[element.order_id].order_idhub].hub_lat, objectMap3[objectMap1[element.order_id].order_idhub].hub_lon,''],
        nombre: objectMap3[objectMap1[element.order_id].order_idhub].hub_name,
        tour_info: {
          order_tour:element.tour_info.order_tour,
          order_pos:0,
          order_vehicle:0,
          transptype_type:element.tour_info.transptype_type,
          transptype:'',
          transptype_capacity_items:0.0,
          transptype_capacity_weight:0.0,
        },
      });
    }
    ant=element.tour_info.order_pos
    elementAnt=element;
  })

  puntos3.push({
    position:'end',
    sumItems:0.0,
    sumWeight:0.0,
    punto1:  [objectMap3[objectMap1[elementAnt.order_id].order_idhub].hub_lat, objectMap3[objectMap1[elementAnt.order_id].order_idhub].hub_lon,''],
    nombre: objectMap3[objectMap1[elementAnt.order_id].order_idhub].hub_name,
    tour_info: {
      order_tour:elementAnt.tour_info.order_tour,
      order_pos:elementAnt.tour_info.order_pos+1,
      order_vehicle:0,
      transptype:'',
      transptype_capacity_items:0.0,
      transptype_capacity_weight:0.0,
    },
  });

  puntos3.sort(function (a, b) {
    if (a.tour_info.order_tour > b.tour_info.order_tour) {
      return 1;
    } else if (a.tour_info.order_tour < b.tour_info.order_tour) {
      return -1;
    } else {
      if (a.tour_info.order_pos < b.tour_info.order_pos) {
        return -1;
      } else if (a.tour_info.order_tour > b.tour_info.order_tour) {
        return 1;
      } else {
        return 0;
      }
    }
  });
  
  var ship_vector=[]

  for (let i = 0; i < routes_data.routes_orders.length+1; i++) {
    ship_vector.push(0)
  }

  var SumPeso=0.0;
  var SumItems=0.0;
  var auxi=0;
  
  for (let i = 0; i < puntos2.length; i++) {
    if(puntos3[i].position==='begin'){
      SumPeso=0.0;
      SumItems=0.0;
      auxi=i;
    }else if(puntos3[i].position==='end'){
      puntos3[auxi].sumWeight=SumPeso;
      puntos3[auxi].sumItems=SumItems;
    }else{
      if(puntos3[i].order_mode==='delivery'){
        SumPeso=SumPeso+parseFloat(puntos3[i].peso)
        SumItems=SumItems+parseFloat(puntos3[i].numberItems)
      }
    }
  }
  
  for (let i = 0; i < puntos3.length; i++) {
    if(puntos3[i].position==='while'){
      if(puntos3[i].order_mode==='pickup'||
      (puntos3[i].order_mode==='shipment' && 
      ship_vector[parseInt(puntos3[i].nombre)]===0)){
        puntos3[i].sumWeight=puntos3[i-1].sumWeight+parseFloat(puntos3[i].peso);
        puntos3[i].sumItems=puntos3[i-1].sumItems+parseFloat(puntos3[i].numberItems);
        puntos3[i].sumWeight=Math.round(puntos3[i].sumWeight*100)
        puntos3[i].sumItems=Math.round(puntos3[i].sumItems*100)
        puntos3[i].sumWeight=puntos3[i].sumWeight/100
        puntos3[i].sumItems=puntos3[i].sumItems/100
        ship_vector[parseInt(puntos3[i].order_id)]=1;
        // console.log('ship0:', ship_vector[parseInt(puntos3[i].order_id)],'punto:',parseInt(puntos3[i].order_id))
      }else if(puntos3[i].order_mode==='delivery'||
      (puntos3[i].order_mode==='shipment' && 
      ship_vector[parseInt(puntos3[i].nombre)]===1)){
        puntos3[i].sumWeight=puntos3[i-1].sumWeight-parseFloat(puntos3[i].peso);
        puntos3[i].sumItems=puntos3[i-1].sumItems-parseFloat(puntos3[i].numberItems);
        puntos3[i].sumWeight=Math.round(puntos3[i].sumWeight*100)
        puntos3[i].sumItems=Math.round(puntos3[i].sumItems*100)
        puntos3[i].sumWeight=puntos3[i].sumWeight/100
        puntos3[i].sumItems=puntos3[i].sumItems/100
        // console.log('ship1:', ship_vector[parseInt(puntos3[i].order_id)],'punto:',parseInt(puntos3[i].order_id))
      }
    }else if(puntos3[i].position==='end'){
      puntos3[i].sumWeight=puntos3[i-1].sumWeight;
      puntos3[i].sumItems=puntos3[i-1].sumItems;
      puntos3[i].tour_info.order_vehicle=puntos3[i-1].tour_info.order_vehicle;
      puntos3[i].tour_info.transptype=puntos3[i-1].tour_info.transptype;
      puntos3[i].tour_info.transptype_capacity_items=puntos3[i-1].tour_info.transptype_capacity_items;
      puntos3[i].tour_info.transptype_capacity_weight=puntos3[i-1].tour_info.transptype_capacity_weight;
    }else if(puntos3[i].position==='begin'){
      puntos3[i].tour_info.order_vehicle=puntos3[i+1].tour_info.order_vehicle;
      puntos3[i].tour_info.transptype=puntos3[i+1].tour_info.transptype;
      puntos3[i].tour_info.transptype_capacity_items=puntos3[i+1].tour_info.transptype_capacity_items;
      puntos3[i].tour_info.transptype_capacity_weight=puntos3[i+1].tour_info.transptype_capacity_weight;
    }
  }


  console.log(puntos3,'puntos3')

  for (let i = 0; i < coordenadas.length; i++) {
    if(coordenadas[i].position=='begin'){
      auxiliare=[]
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      vehicleType.push([coordenadas[i].tour_info.transptype_type])
    }else if(coordenadas[i].position=='end'){
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      auxiliares=[...auxiliares,auxiliare]
    }else{
       auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
    }
  }

  for (let i = 0; i < coordenadas.length; i++) {
    if (filtrarTour(coordenadas[i].tour_info.order_tour, checked)) 
    { 
      puntos.push(coordenadas[i].punto1);
      peso.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumWeight});
      volumen.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumItems});
      altura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:parseInt(coordenadas[i].punto1[2])});
      

      if ((i)!==coordenadas.length-1)
        {if(coordenadas[i+1].tour_info.order_pos!==0 ){
          var fromLatLng = L.latLng(coordenadas[i].punto1[0],coordenadas[i].punto1[1]);
          var toLatLng = L.latLng(coordenadas[i+1].punto1[0],coordenadas[i+1].punto1[1]);
          var dis = fromLatLng.distanceTo(toLatLng);
          
          dif=parseInt(coordenadas[i+1].punto1[2])-parseInt(coordenadas[i].punto1[2]);
          (dif===0 || dis ===0)?difpen=0:difpen= 100*dif/dis;
          pendientes.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:difpen})
          difaltura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:dif})
        }
      }
      
     
      if(coordenadas[i].tour_info.order_pos!==0 && coordenadas[i].hub==null){
        rutas.push(<Routing /* ref={routingRef} */ color={colorP} waypoints={puntos}/>)
        // console.log('rutas: ',rutas)
        puntos=[];
        (colorP==='red')?colorP='green':(colorP==='green')?colorP='brown':colorP='red';
      }
      orden = orden + coordenadas[i].nombre + "-> ";
      if(coordenadas[i].order_mode==='delivery'){
        color='green';
      }else if(coordenadas[i].order_mode==='pickup'){
        color='red';
      }else if(coordenadas[i].order_mode==='shipment'){
        color='orange';
      }else{
        color='white';
      }

      
      if(i===coordenadas.length-1){
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           html: `<div class="hub-hidden">
           </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
               ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
      }else{
        puntos2.push(
          <Marker 
            icon={L.divIcon({
              html: (coordenadas[i].tour_info.order_pos===0 )
              ?`<div class="blue-square" ></div>`
              :`<div class="hub-hidden"></div>`,
            })}
            position={coordenadas[i].punto1}>
                <Popup  
                className="popUpHub"
                closeButton={false}
                >
                <div className="popUpHub-top">
                    {coordenadas[i].nombre} 
                  </div>
                <div className="popUpHub-in">
                  <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
                  <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
                  <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
                  <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
                  <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
                  <h4>Items en vehículo: {coordenadas[i].sumItems} </h4>
                  <h4>Peso de los items: {coordenadas[i].sumWeight} </h4>
                </div>
                
                </Popup> 
   
           </Marker> 
         );
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           
           html: (coordenadas[i].tour_info.order_pos===0  || coordenadas[i+1].tour_info.order_pos===0 )?`<div class="hub-hidden">
           </div>`
           :`<div class="marker-capillar">
              <div class="${color}-circle" >
              </div>
              <div class="number" >
                  ${coordenadas[i].tour_info.order_pos}
              </div>
              
              
            </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
                ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
         
      }
      
    }
  }

  for (let i = 0; i < puntos3.length; i++) {
    if(puntos3[i].position=='begin'){
      auxiliare_r=[]
      auxiliare_r.push([puntos3[i].punto1[0],puntos3[i].punto1[1]])
      vehicleType_r.push([puntos3[i].tour_info.transptype_type])
    }else if(puntos3[i].position=='end'){
      auxiliare_r.push([puntos3[i].punto1[0],puntos3[i].punto1[1]])
      auxiliare_r.push([puntos3[i].punto1[0],puntos3[i].punto1[1]])
      auxiliares_r=[...auxiliares,auxiliare]
    }else{
       auxiliare_r.push([puntos3[i].punto1[0],puntos3[i].punto1[1]])
    }
  }

  for (let i = 0; i < puntos3.length; i++) {
    // console.log('estoy',filtrarTour_r(puntos3[i].tour_info.order_tour, checked_r),puntos3[i].tour_info.order_tour,checked_r)
    if (filtrarTour_r(puntos3[i].tour_info.order_tour, checked_r)) {
      // console.log('esto in') 
      puntos_r.push(puntos3[i].punto1);
      peso_r.push({category: puntos3[i].tour_info.order_tour,position: puntos3[i].tour_info.order_pos,weight:puntos3[i].sumWeight});
      volumen_r.push({category: puntos3[i].tour_info.order_tour,position: puntos3[i].tour_info.order_pos,weight:puntos3[i].sumItems});
      altura_r.push({category: puntos3[i].tour_info.order_tour,position: puntos3[i].tour_info.order_pos,weight:parseInt(puntos3[i].punto1[2])});
      

      if ((i)!==puntos3.length-1)
        {if(puntos3[i+1].tour_info.order_pos!==0 ){
          var fromLatLng = L.latLng(puntos3[i].punto1[0],puntos3[i].punto1[1]);
          var toLatLng = L.latLng(puntos3[i+1].punto1[0],puntos3[i+1].punto1[1]);
          var dis = fromLatLng.distanceTo(toLatLng);
          
          dif=parseInt(puntos3[i+1].punto1[2])-parseInt(puntos3[i].punto1[2]);
          (dif===0 || dis ===0)?difpen=0:difpen= 100*dif/dis;
          pendientes_r.push({category: puntos3[i].tour_info.order_tour,position: puntos3[i].tour_info.order_pos,weight:difpen})
          difaltura_r.push({category: puntos3[i].tour_info.order_tour,position: puntos3[i].tour_info.order_pos,weight:dif})
        }
      }
      
     
      if(puntos3[i].tour_info.order_pos!==0 && puntos3[i].hub==null){
        rutas_r.push(<Routing /* ref={routingRef} */ color={colorP} waypoints={puntos_r}/>)
        // console.log('rutas: ',rutas)
        puntos_r=[];
        (colorP==='red')?colorP='green':(colorP==='green')?colorP='brown':colorP='red';
      }
      orden = orden + puntos3[i].nombre + "-> ";
      if(puntos3[i].order_mode==='delivery'){
        color='green';
      }else if(puntos3[i].order_mode==='pickup'){
        color='red';
      }else if(puntos3[i].order_mode==='shipment'){
        color='orange';
      }else{
        color='white';
      }

      
      if(i===puntos3.length-1){
        puntos3_r.push(
          <Marker 
          icon={L.divIcon({
           html: `<div class="hub-hidden">
           </div>`,
         })}
           position={puntos3[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
               ORDER ID: {puntos3[i].nombre} <span>({puntos3[i].order_mode} {puntos3[i].earlyTime1}-{puntos3[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {puntos3[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {puntos3[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {puntos3[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*puntos3[i].sumWeight/puntos3[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*puntos3[i].sumItems/puntos3[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {puntos3[i].numberItems} </h4>
              <h4>Peso de los items: {puntos3[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
      }else{
        puntos3_r.push(
          <Marker 
            icon={L.divIcon({
              html: (puntos3[i].tour_info.order_pos===0 )
              ?`<div class="blue-square" ></div>`
              :`<div class="hub-hidden"></div>`,
            })}
            position={puntos3[i].punto1}>
                <Popup  
                className="popUpHub"
                closeButton={false}
                >
                <div className="popUpHub-top">
                    {puntos3[i].nombre} 
                  </div>
                <div className="popUpHub-in">
                  <h4>Vehículo: {puntos3[i].tour_info.transptype} </h4>
                  <h4>Capacidad peso: {puntos3[i].tour_info.transptype_capacity_weight} </h4>
                  <h4>Capacidad items: {puntos3[i].tour_info.transptype_capacity_items} </h4>
                  <h4>% de ocupación <span>(peso)</span>: {(100*puntos3[i].sumWeight/puntos3[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
                  <h4>% de ocupación <span>(items)</span>: {(100*puntos3[i].sumItems/puntos3[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
                  <h4>Items en vehículo: {puntos3[i].sumItems} </h4>
                  <h4>Peso de los items: {puntos3[i].sumWeight} </h4>
                </div>
                
                </Popup> 
   
           </Marker> 
         );
        puntos3_r.push(
          <Marker 
          icon={L.divIcon({
           
           html: (puntos3[i].tour_info.order_pos===0  || puntos3[i+1].tour_info.order_pos===0 )?`<div class="hub-hidden">
           </div>`
           :`<div class="marker-capillar">
              <div class="${color}-circle" >
              </div>
              <div class="number" >
                  ${puntos3[i].tour_info.order_pos}
              </div>
              
              
            </div>`,
         })}
           position={puntos3[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
                ORDER ID: {puntos3[i].nombre} <span>({puntos3[i].order_mode} {puntos3[i].earlyTime1}-{puntos3[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {puntos3[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {puntos3[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {puntos3[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*puntos3[i].sumWeight/puntos3[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*puntos3[i].sumItems/puntos3[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {puntos3[i].numberItems} </h4>
              <h4>Peso de los items: {puntos3[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
         
      }
      
    }
    // console.log('rr:', rutas_r,puntos3_r)
  }

 
  function myFunction() {
    var popup = document.getElementById("myPopup");
    popup.classList.toggle("show");
  }

  const onChange = (checkedValues) => {
    setchecked(checkedValues);
  };

  function filtrarTour(value, checkboxs) {
    var tour_elegido = false;
    for (let i = 0; i < checkboxs.length; i++) {
      if (value === checkboxs[i]) {
        tour_elegido = true;
        break;
      }
    }
    return tour_elegido;
  }
  const onChange_r = (checkedValues) => {
    setchecked_r(checkedValues);
  };

  function filtrarTour_r(value, checkboxs) {
    var tour_elegido = false;
    for (let i = 0; i < checkboxs.length; i++) {
      if (value === parseInt(checkboxs[i])) {
        tour_elegido = true;
        break;
      }
    }
    return tour_elegido;
  }
  var num_tours_v = [];
  var num_tours_r = [];
  var rutas_descargar = [];
  var rutas_descargar_r = [];
  var aux= parseInt(coordenadas[coordenadas.length-1].tour_info.order_tour)+1; 
  var aux_r= parseInt(puntos3[puntos3.length-1].tour_info.order_tour)+1; 
  
  for (let i = 0; i < aux; i++) {
    num_tours_v.push(<Checkbox value={i.toString()}>{i}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>);
    rutas_descargar.push(
      <Button className="boton"
        disabled={/* disable */false}
        style={{borderColor: "rgb(203,234,247)", 
        backgroundColor: "rgb(203,234,247)" ,
        color:'rgb(0,104,178)',
        fontFamily:'report',
        fontSize:'17px',
        marginRight:'10px'}}
        type="primary"
        onClick =  {() =>
          copiarTexto(auxiliares[i])
          }>
        {i}&nbsp;{vehicleType[i][0]}
      </Button>
    );

  }
  for (let i = 0; i < aux_r; i++) {
    num_tours_r.push(<Checkbox value={i.toString()}>{i}&nbsp;RD&nbsp;&nbsp;</Checkbox>);
    rutas_descargar_r.push(
      <Button className="boton"
        disabled={/* disable */false}
        style={{borderColor: "rgb(62,95,138)", 
        backgroundColor: "rgb(62,95,138)" ,
        color:'white',
        fontFamily:'report',
        fontSize:'17px',
        marginRight:'10px'}}
        type="primary"
        onClick =  {() =>
          copiarTexto(auxiliares_r[i])
          }>
        {i}&nbsp;{vehicleType[i][0]}
      </Button>
    );

  }

  return (
    <>
    <Billing_rr
          objectMap1={objectMap1} 
          objectMap2={objectMap2} 
          objectMap3={objectMap3} 
          objectMap4={objectMap4} 
          setiva={setiva} 
          iva={iva} 
          rutas={puntos3}></Billing_rr>
    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.3/dist/leaflet.css"
     integrity="sha256-kLaT2GOSpHechhsozzB+flnD+zUyjE2LlfWPgU04xyI="
     crossOrigin=""/>
      <script src="https://unpkg.com/leaflet@1.9.3/dist/leaflet.js"
     integrity="sha256-WBkoXOwTeyKclOHuWtc+i2uENFpDZ9YPdf5Hf+D7ewM="
     crossOrigin=""></script>
     {
      (checked.length>0)
        ?<p>{orden}</p>
        :<div></div>
      }
      <div className="leyenda">
      <div className="rutas" style={{display:'flex',flexFlow:'column' }}>
        <Checkbox.Group style={{marginBottom:'10px', width: "100%" }} onChange={onChange}>
          {num_tours_v}
        </Checkbox.Group>
          <div className="rutas" style={{display:'flex',flexFlow:'row',marginBottom:'10px' }}>
            {rutas_descargar}
          </div>
        <Checkbox.Group style={{marginBottom:'10px', width: "100%" }} onChange={onChange_r}>
          {num_tours_r}
        </Checkbox.Group>
          <div className="rutas" style={{display:'flex',flexFlow:'row',marginBottom:'10px' }}>
            {rutas_descargar_r}
          </div>
        </div>

        <div style={{display:'flex',flexFlow:'row',alignItems:'center' }}>
            <div className="orange">
            </div>
            <div className="shipment">
            shipment
            </div>
            <div className="rojo">
            </div>
            <div className="pick-up">
            pick-up
            </div>
            <div className="verde">
            </div>
            <div className="delivery">
            delivery
            </div>
            <div className="azul">
            </div>
            <div className="hubs">
            hubs
            </div>
            </div>
        </div>
      <div className="mapaRow">
        <MapContainer
          ref={mapRef}
          className="leaflet-container"
          center={coordenadas[0].punto1}
          zoom={12}
        >
          
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {rutas}
          {puntos2}
          {rutas_r}
          {puntos3_r}
        </MapContainer>
      </div>
      {/* {(checked_r.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Route evolution (€)</p>
          <LineGraphEconomic
            data={gananciasRutaAcc}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>} */}
    </>
  );
}
